import { supabase } from '../../supabaseClient'

export async function saveUserSettings({
  userId,
  timezone,
  operationalDayStart,
  focusCount,
  pausedMode,
  defaultFocusAreaId,
  defaultDailyFlowId,
  defaultDayTypeId
}) {

  const { error: profileError } = await supabase
    .from('profiles')
    .update({
      timezone,
      operational_day_start: operationalDayStart,
      updated_at: new Date().toISOString()
    })
    .eq('id', userId)

  if (profileError) {
    throw profileError
  }

const { data: updatedPreferences, error: preferencesError } = await supabase
  .from('user_preferences')
  .update({
    default_focus_count: focusCount,
    pause_mode: pausedMode,
    default_focus_area_id: defaultFocusAreaId || null,
    default_daily_flow_id: defaultDailyFlowId || null,
    default_day_type_id: defaultDayTypeId || null,
    updated_at: new Date().toISOString()
  })
  .eq('user_id', userId)
  .select()

if (preferencesError) {
  throw preferencesError
}

  return true
}

export async function fetchUserPreferences(userId) {
    const { data, error } = await supabase
        .from('user_preferences')
        .select('*')
        .eq('user_id', userId)
        .single()

    if (error) {
        throw error
    }

    return data
}

export async function fetchPauseModePreference(userId) {
  const { data, error } = await supabase
    .from('user_preferences')
    .select('pause_mode')
    .eq('user_id', userId)
    .single()

  if (error) {
    throw error
  }

  return data.pause_mode
}